import ScButton from "@/src/components/ui-kit/button";
import { usePwaInstall } from "@/src/hooks/features/pwa/use-pwa-install";
import { useTranslation } from "react-i18next";
import { Text, View } from "react-native";

/**
 * "Install app" for Settings → Account.
 *
 * Mirrors the sections around it (heading, block with a top border, button, hint),
 * and renders nothing at all when there is nothing to offer — already installed, or
 * a browser that cannot install (desktop Firefox, iOS Chrome). Explaining an action
 * that does not exist is worse than the section being absent.
 */
const InstallAppCard = () => {
  const { t } = useTranslation();
  const {
    canPrompt,
    showIosSteps,
    iosNeedsSafari,
    isInstalled,
    promptInstall,
  } = usePwaInstall();

  if (isInstalled) return null;
  if (!canPrompt && !showIosSteps && !iosNeedsSafari) return null;

  return (
    <View>
      <Text className="font-medium text-lg px-4 pb-4 mt-6 text-onyx">
        {t("LABEL_INSTALL_APP")}
      </Text>
      <View className="flex-col p-4 gap-3 border-t items-start border-ash-3">
        {canPrompt && (
          <>
            <ScButton
              text="BTN_INSTALL_APP"
              onPress={() => {
                void promptInstall();
              }}
            />
            <Text className="text-gray-dark">{t("HINT_INSTALL_APP")}</Text>
          </>
        )}

        {/* iOS Safari: no prompt exists, so the steps are the whole feature. */}
        {showIosSteps && (
          <>
            <Text className="font-medium text-onyx">
              {t("LABEL_ADD_TO_HOME_SCREEN")}
            </Text>
            <Text className="text-gray-dark">{t("HINT_INSTALL_IOS")}</Text>
          </>
        )}

        {/* iOS, but a browser that cannot install: do not send them looking. */}
        {iosNeedsSafari && (
          <Text className="text-gray-dark">{t("HINT_INSTALL_IOS_SAFARI")}</Text>
        )}
      </View>
    </View>
  );
};

export default InstallAppCard;
